import React, { Component } from 'react';
import styled from 'styled-components';
import { fmt } from '../model/dashboardCalc';

const W = 740;
const H = 260;
const L = 43;
const R = 15;
const T = 18;
const B = 33;

// 단일 시리즈 막대 차트 (LineChart 와 동일한 축/라벨 스타일, 마우스 오버 시 값 툴팁)
class BarChart extends Component {
  state = { hoverIdx: null };

  render() {
    const { values, labels, ariaLabel } = this.props;
    const { hoverIdx } = this.state;
    const max = Math.max(...values, 1) * 1.16;
    const band = (W - L - R) / Math.max(values.length, 1);
    const barW = Math.min(band * 0.6, 36);
    const cx = (i) => L + band * (i + 0.5);
    const y = (v) => H - B - ((H - T - B) * v) / max;
    const labelStep = Math.ceil(labels.length / 7);

    // 툴팁 위치: 막대 위 중앙 (차트 좌우 끝에서 잘리지 않도록 보정)
    let tip = null;
    if (hoverIdx !== null && hoverIdx < values.length) {
      const text = `${labels[hoverIdx]} · ${fmt(values[hoverIdx], 1)} kWh`;
      const tipW = text.length * 7 + 20;
      const tipH = 26;
      const tx = Math.min(Math.max(cx(hoverIdx) - tipW / 2, L), W - R - tipW);
      const ty = Math.max(y(values[hoverIdx]) - tipH - 8, 0);
      tip = { text, tipW, tipH, tx, ty };
    }

    return (
      <Svg
        viewBox={`0 0 ${W} ${H}`}
        role="img"
        aria-label={ariaLabel}
        onMouseLeave={() => this.setState({ hoverIdx: null })}
      >
        <defs>
          <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#5ebcff" />
            <stop offset="1" stopColor="#399cfa" stopOpacity=".55" />
          </linearGradient>
        </defs>
        {[0, 1, 2, 3, 4].map((k) => {
          const v = (max * k) / 4;
          const yy = y(v);
          return (
            <g key={`tick-${k}`}>
              <line className="axis" x1={L} y1={yy} x2={W - R} y2={yy} />
              <text x={L - 9} y={yy + 4} textAnchor="end">
                {fmt(v, 0)}
              </text>
            </g>
          );
        })}
        {labels.map((label, i) =>
          i % labelStep === 0 || i === labels.length - 1 ? (
            <text key={`label-${i}`} x={cx(i)} y={H - 10} textAnchor="middle">
              {label}
            </text>
          ) : null
        )}
        {values.map((v, i) => (
          <rect
            key={`bar-${i}`}
            className={`bar ${hoverIdx === i ? 'active' : ''}`}
            x={cx(i) - barW / 2}
            y={y(v)}
            width={barW}
            height={H - B - y(v)}
            rx="3"
          />
        ))}
        {/* 값이 작은 막대도 쉽게 오버되도록 구간 전체 높이를 감지 영역으로 사용 */}
        {values.map((v, i) => (
          <rect
            key={`hit-${i}`}
            className="hit"
            x={L + band * i}
            y={T}
            width={band}
            height={H - T - B}
            onMouseEnter={() => this.setState({ hoverIdx: i })}
          />
        ))}
        {tip && (
          <g className="bar-tip" pointerEvents="none">
            <rect x={tip.tx} y={tip.ty} width={tip.tipW} height={tip.tipH} rx="6" />
            <text x={tip.tx + tip.tipW / 2} y={tip.ty + 17} textAnchor="middle">
              {tip.text}
            </text>
          </g>
        )}
      </Svg>
    );
  }
}

const Svg = styled.svg`
  width: 100%;
  height: 255px;
  display: block;
  overflow: visible;

  text {
    font-size: 11px;
    fill: #849bb9;
  }
  .axis {
    stroke: #273a52;
    stroke-width: 1;
  }
  .bar {
    fill: url(#barGradient);

    &.active {
      fill: #7ac6ff;
    }
  }
  .hit {
    fill: transparent;
    cursor: pointer;
  }
  /* 전역 .tooltip(bootstrap, opacity: 0) 과 충돌하지 않도록 bar-tip 사용 */
  .bar-tip {
    rect {
      fill: #0b1422;
      stroke: #3a5578;
      stroke-width: 1;
    }
    text {
      font-size: 12px;
      font-weight: 600;
      fill: #edf3fc;
    }
  }

  @media (max-width: 700px) {
    height: auto;
    min-height: 180px;
    max-height: 250px;
  }
`;

export default BarChart;
